import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICreateOrderDelivery } from "./interfaces/create-business-partner-order.interface";
import { IUpdateOrderDelivery } from "./interfaces/update-business-partner-order.interface";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "sub_route_delivery_windows";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerOrderService extends AbstractService<
orderDeliveryWindowsAttributes,
ICreateOrderDelivery,
IUpdateOrderDelivery
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string): Observable<IResult<orderDeliveryWindowsAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}`;
    return this.http.get<IResult<orderDeliveryWindowsAttributes>>(API_URL);
  }
}